import React from 'react';
import { StyleSheet, View } from 'react-native';
import { AppText } from '../AppText';
import Colors from '../../constants/Colors';
import { useTranslation } from '../../providers/TranslationProvider';

const styles = StyleSheet.create({
  container: {
    padding: 16,
    paddingHorizontal: 18,
    backgroundColor: Colors.white,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grayBorder,
  },
  count: {
    fontSize: 13,
    color: Colors.mediumGray,
  },
});

export interface SiteListHeaderProps {
  resultCount: number;
}

// `t()` does plain {{param}} interpolation with no plural support, so the singular/zero forms
// are separate keys and the branch happens here rather than in the locale files.
function resultCountKey(resultCount: number): string {
  if (resultCount === 0) return 'site_list_result_count_zero';
  if (resultCount === 1) return 'site_list_result_count_one';
  return 'site_list_result_count';
}

// The search box is deliberately not here -- SiteMapPantriesContent owns it, above both the map
// and list panels, so this component only owns the result count.
export function SiteListHeader({ resultCount }: SiteListHeaderProps) {
  const { t } = useTranslation();

  return (
    <View style={styles.container} testID="site-list-header">
      <AppText style={styles.count}>{t(resultCountKey(resultCount), { count: String(resultCount) })}</AppText>
    </View>
  );
}
